//Please add the language resource
const routeTrack = {
  obnExtId: 'obnExtId',
  tmsSystemNumber: 'tmsSystemNumber',
  carrierNo: 'carrierNo',
  carrierName: 'carrierName',
  shipperCode: 'shipperCode',
  customerCode: 'customerCode',
  projectCode: 'projectCode',
  province: 'province',
  city: 'city',
  currentStatus: 'currentStatus',
  operateTime: 'operateTime',
  recipient: 'recipient',
  operatorPhone: 'operatorPhone',
  orderStatus: 'orderStatus',
  routeId: 'routeId',
  routeType: 'routeType',
  routeDescribe: 'routeDescribe',
  routeSimpleDescribe: 'routeSimpleDescribe',
  routeTime: 'routeTime',
  pushParam: 'pushParam',
  pushTime: 'pushTime',
  pushStatus: 'pushStatus',
  pushCount: 'pushCount',
  pushResult: 'pushResult',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater'
};
export default routeTrack



// WEBPACK FOOTER //
// ./src/page/transit/routeTrack/lang/routeTrack.en.js